import React, { Component } from 'react'

import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import { Button, IconButton, InputAdornment, Paper, TextField } from '@material-ui/core';
import { Search, HighlightOff } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { sweetAlert } from '../../components/Alert/sweetAlert';


class ItemIconsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected:'',
            search:'',
            IconsArr:[]
        };
    };

    componentDidMount(){

        if(this.props.icons){
            this.setState({IconsArr:this.props.icons})
        }

        if(this.props.iconSelected){
            this.setState({selected:this.props.iconSelected});
        }
    }
  
  
    handleSelectIcon=(icon)=>{
        this.setState({selected: icon})   
    }
  
    SearchIcon=(search)=>{
        const value=search.toLowerCase();
          
        if(value ===''){
            this.ClearSearch()

        }else if(value!==undefined && value !==''){

            this.setState({search:value.toLowerCase()},()=>{
                const icons=this.props.icons?this.props.icons:[]
    
                const iconsFilered = icons.filter(element => {
                    
                    var existTag = element.tags.find(tag=>tag.toLowerCase().includes(value))
                    return existTag;
                });
        
                this.setState({IconsArr:iconsFilered});
            });

                          
         
          }
      };
  
    ClearSearch=()=>{
        let icons=this.props.icons;
        this.setState({IconsArr:icons, search:''});
    }

    handleDone=()=>{
        if(!this.state.selected){
            sweetAlert('error','Please select an icon')
            return;
        }
        
        this.props.onDone(this.state.selected);
    }

    handleCancel =()=>{
        this.setState({selected:'', search:'', icons:this.props.icons});
        this.props.onCancel();
    }

    render() {
        return (
            <>
                <Paper elevation={3} square='false' color='secondary'>
                    <Grid id='icons_modal' className="LpaperModalIcon" style={{padding:'40px 20px 40px 40px'}}>
                        {/* <Grid item container xs={12} style={{height:'100%'}}>

                        </Grid> */}
                        <Grid item className="lmodalTitle" style={{height:'10%'}}>Select an Icon</Grid>

                        <Grid item container xs={12} alignItems='baseline' justifyContent='center' style={{height:'80%'}}>

                            <Grid item container xs={11} alignItems='flex-start' justifyContent='space-between' style={{height:'100%'}}>
                                {/* Search component */}
                                <Grid item container xs={12} alignItems='center' justifyContent='space-between' style={{heigth:'20%', margin:'1rem 0rem'}}>
                                    <Grid item xs={12} sm={8} md={8} lg={8} className="MuiInput-input">
                                        <TextField
                                            id='icons_modal_search'
                                            name='Search'
                                            placeholder='Search'
                                            autoFocus={true}
                                            value={this.state.search}
                                            fullWidth
                                            style={{backgroundColor: 'white', padding:'10px 15px' ,borderRadius: '30px', color:'black' }}
                                            InputProps={{
                                                className:'textField MuiInput-input',
                                                disableUnderline:true,
                                                startAdornment:(
                                                    <InputAdornment position="start">
                                                        <Search style={{color:'black', fontSize:40}} />
                                                    </InputAdornment>
                                                ),
                                                endAdornment:(
                                                <InputAdornment position="end">
                                                        <IconButton id='icons_modal_clear_btn' onClick={this.ClearSearch}>
                                                            <HighlightOff style={{color:'black', fontSize:40}} />
                                                        </IconButton>
                                                    </InputAdornment>  
                                                )
                                            }}
                                            inputProps={{
                                                className:'txt_black'
                                            }}
                                            onChange={(e)=>this.SearchIcon(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3} lg={3} style={{color:'black', fontSize:'32px', fontFamily:'Gotham-Book',paddingLeft:'1rem'}}>
                                        {`${this.state.IconsArr.length} Icons`}
                                    </Grid>

                                </Grid>
                            
                                {/* Icons list */}
                                <Grid item container xs={12} justifyContent='flex-start' id='icons_modal_container' style={{height:'80%', overflowY:'scroll'}}>
                                    {
                                        this.state.IconsArr && this.state.IconsArr.map((item)=>{

                                            const isSelected = this.state.selected?.iconUrl ===item.iconUrl
                                            return(
                                                <Grid item container  xs={12} sm={6} md={4} lg={4} style={{padding:'1rem'}} key={`icon_card_${item._id}`}>
                                                    <Grid item container alignItems='center' justifyContent='center' 
                                                        className="LiconCard" xs={12}
                                                        onClick={()=>this.handleSelectIcon(item)}
                                                        id={`icon_${item._id}`}
                                                        style={{backgroundColor:(isSelected)?'#009EDD':'white'}}
                                                    >
                                                        {
                                                            this.state.selected?.iconUrl === item.iconUrl &&
                                                            <Grid item container xs={12} justifyContent='flex-end'>
                                                                <FontAwesomeIcon
                                                                    icon={faCheckCircle}
                                                                    color='white'
                                                                    size='lg'
                                                                    style={{opacity:'0.56'}}
                                                                />
                                                            </Grid>
                                                        
                                                        }
                                                        <img
                                                            item
                                                            src={item.iconUrl}
                                                            alt='icon'
                                                            className={!isSelected? "iconImg Llogo-black":"iconImg"}
                                                        />
                                                        <Grid item xs={12} className="LIconName">{item.itemName?item.itemName:item.name}</Grid>    
                                                    </Grid>
                                                </Grid>
                                            
                                            )
                                        })
                                    }
                                </Grid>

                              
                            </Grid>
                        </Grid>

                         {/* Buttons section */}
                         <Grid item container justifyContent='space-between' alignItems='center' xs={12}  style={{height:'10%'}}>
                            <Button item container className="lcancelBtn" onClick={this.handleCancel}>
                                Cancel
                            </Button>
                            <Button item container className="Lsetup_btn" onClick={this.handleDone}>
                                Done
                            </Button>
                        </Grid>
                    
                    
                    </Grid>
            
                </Paper>

            </>
        )
    }
}

function mapStateToProps(state) {
    const icons = state.itemReducer && state.itemReducer.itemsIconsData ? state.itemReducer.itemsIconsData : [];
    return {
        icons
    }
};

export default connect(mapStateToProps, {})(ItemIconsModal);
